(function () {
  'use strict';


  angular
    .module('cosmicRadiationReport')
    .controller('CosmicRadiationReportCtrl', CosmicRadiationReportCtrl);

  function CosmicRadiationReportCtrl(CommonMasterData,$sce, CommonLogicService) {
    var vm = this;
    vm.ctrlName = 'CosmicRadiationReportCtrl';
  vm.model = {
			searchPanelToggle : true,
			searchCriteria : {
				fromDate : null,
				toDate : null,
				sectors:[],
				crewTypeCodesList:[],
				fleets:[],
				states:[],
				accStart:null,
				accEnd:null
			},
			masterList : {
				sectors : [],
				fromDateFormatInvalid : false,
				toDateFormatInvalid : false,
				fromDateAfterToDate : false,
				crewTypes:[],
				fleetTypes:[]
			},
			initialSearchDone : false,
			reportDataURL : null,
			reportServerBaseUrl : null
		};

		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
			vm.model.initialSearchDone = false;
		};

		vm.submitSearch = function(params) {
			searchCosmicRadiationReport(params);
		};

		vm.changeSearchField = function(searchParams, flag) {
			setDateValidationFlags();
			validateAccumulatedRange();
			if (!vm.model.masterList.toDateFormatInvalid
					&& !vm.model.masterList.fromDateFormatInvalid) {
				if (istoDateBeforeFromDate()) {
					vm.model.masterList.fromDateAfterToDate = true;
				} else {
					vm.model.masterList.fromDateAfterToDate = false;
				}
			} else {
				vm.model.masterList.fromDateAfterToDate = false;
			}
		};

		function validateAccumulatedRange(){
		  if(vm.model.searchCriteria.accEnd!== null && vm.model.searchCriteria.accStart !== null &&
		  (vm.model.searchCriteria.accEnd) < (vm.model.searchCriteria.accStart)){
		    vm.model.masterList.accRangeInvalid = true;
		  }else{
		    vm.model.masterList.accRangeInvalid = false;
		  }
		}

		function setDateValidationFlags() {
			if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
				vm.model.masterList.fromDateFormatInvalid = true;
			} else {
				vm.model.masterList.fromDateFormatInvalid = false;
			}

			if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
				vm.model.masterList.toDateFormatInvalid = true;
			} else {
				vm.model.masterList.toDateFormatInvalid = false;
			}
		}

		function isDateFormatInvalid(date) {
			if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
				return true;
			}
			return false;
		}

		function istoDateBeforeFromDate() {
			return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
					.isBefore(moment(vm.model.searchCriteria.fromDate,"DD/MM/YYYY"));
		};

		// search report
		function searchCosmicRadiationReport(param) {
			vm.model.initialSearchDone = true;
			if (isValidSearchParams(param)) {
				vm.model.searchCriteria = param;
				vm.model.searchPanelToggle = false;
				var url = CommonLogicService.getReportUrl(
						'cosmic_radiation.rptdesign', getSearchParamMap(param));
				vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
			}
		}

		function getSearchParamMap(param) {
			var searchParamMap = {};
			searchParamMap["fromDate"] = isNull(param.fromDate)?"":(param.fromDate);
			searchParamMap["toDate"] = isNull(param.toDate)?"":(param.toDate);
			searchParamMap["sectors"] = createCommaSeparatedString(param.sectors,"sectorName");
			searchParamMap["crewTypes"] = createCommaSeparatedString(param.crewTypeCodesList,"crewTypeCode");
			searchParamMap["fleets"] = createCommaSeparatedString(param.fleets,"airCraftType");
			searchParamMap["states"] = createCommaSeparatedString(param.states,"limitDescription");
      searchParamMap["accStart"] = isNull(param.accStart)?"":param.accStart;
      searchParamMap["accEnd"] = isNull(param.accEnd)?"":param.accEnd;
      searchParamMap["referrer"] = window.location.origin;
			return searchParamMap;
		}

    function isNull(value){
      if(value === null || angular.isUndefined(value)){
         return true;
      }else{
         return false;
      }
    }

    function allSelected(list){
      if(list.length === vm.model.masterList.sectors.length){
        return true;
      }
      return false;
    }

     function createCommaSeparatedString(list, valueFieldName) {
        if(list === null || list.length === 0 || angular.isUndefined(list)){
          return "";
        }

        var commaSeparatedString = '';
        for (var j = 0; j < list.length; j++) {
          var  obj = Object(list[j]);
          if (j == 0) {
             commaSeparatedString = obj[valueFieldName];
          } else {
             commaSeparatedString += ',' + obj[valueFieldName];
          }
        }
        return commaSeparatedString;
      }


		function isValidSearchParams(params) {
			setDateValidationFlags();
			if (vm.model.masterList.toDateFormatInvalid
					|| vm.model.masterList.fromDateFormatInvalid) {
				return false;
			} else if (istoDateBeforeFromDate()) {
				vm.model.masterList.fromDateAfterToDate = true;
				return false;
			} else {
				vm.model.masterList.fromDateAfterToDate = false;
				return true;
			}
		}

		(function() {

      CommonMasterData.getCrewTypeList(function (response) {
          vm.model.masterList.crewTypes = response;
      },function (error) {});

      CommonMasterData.getAircraftModels(function (airCraftList) {
           vm.model.masterList.fleetTypes = airCraftList;
      }, function () {
            console.log('Aircraft type retrieval error');
      });

      CommonMasterData.getSectors(function (sectors) {
           vm.model.masterList.sectors = sectors;
      }, function () {
           console.log('sector details retrieval error');
       });

      CommonMasterData.getExposureLimits(function (states) {
          vm.model.masterList.states = states;
      }, function () {
         console.log('states retrieval error');
      });

		})();
	}
}());
